export function normalizePropertyList(list = []) {
  return (Array.isArray(list) ? list : []).map((item, index, arr) => {
    const source = arr[index] || item;
    const id = source.id;

    return {
      ...source,
      id,
      frontPageImg: source.frontPageImg,
      agencyImg: source.agencyImg ?? null,
      agentImg: source.agentImg ?? null,
      lead_agent: source.lead_agent,
      price: source.price,
      price_display_checked: source.price_display_checked,
      price_display: source.price_display,
      street_address_number: source.street_address_number,
      street_address_name: source.street_address_name,
      bedroomCount: source.Bedrooms,
      showerCount: source.Bathrooms,
      carCount: source.carport_spaces,
      squareCount: "6,580 m2",
      appartmentCount: "",
      acreageCount: source.property_type,
      primary_color: source.primary_color,
      secondary_color: source.secondary_color,
      text_color: source.text_color,
      collections: source.collections,

    };
  });
}
